import ExpiredStorage from "expired-storage"
const localStorageService = new ExpiredStorage()

const SEARCHES_STORAGE_EXPIRES_IN = 345600 // 4 days in seconds (60 * 60 * 24 * 4)

const writeAndMerge = (key, payload) => {
  let payloadToWrite = { ...payload }

  const previousPayload = read(key)
  if (previousPayload) {
    payloadToWrite = { ...previousPayload, ...payloadToWrite }
  }

  localStorageService.setJson(key, payloadToWrite, SEARCHES_STORAGE_EXPIRES_IN)
}

const read = key => localStorageService.getJson(key)

const clear = key => localStorageService.removeItem(key)

const expiresIn = key => localStorageService.getTimeLeft(key)

export default {
  writeAndMerge,
  read,
  clear,
  expiresIn
}
